import { useBreakpointValue } from "@gluestack-style/react";
import { useGeneratePdf } from "@repo/core/hooks/useGeneratePdf";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { DailyClosing } from "@repo/core/services/entities/Transactions";
import { apiInstance } from "@repo/core/services/instances/api";
import { TransactionsResource } from "@repo/core/services/resources/transactions";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const transactionsResource = new TransactionsResource(apiInstance);

export const SecondCopyOfReceiptController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { back, replace } = useNavigation();
  const {
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading: pdfIsLoading
  } = useGeneratePdf();

  const { data: dailyData, isLoading } = useQuery({
    queryKey: ["dailyClosing"],
    queryFn: () => transactionsResource.dailyClosing()
  });

  const dailyInfo: DailyClosing = useMemo(() => {
    if (dailyData?.data) {
      return JSON.parse(dailyData?.data);
    }

    return {} as DailyClosing;
  }, [dailyData]);

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };
  return {
    isLoading,
    dailyInfo,
    viewRef,
    handleCaptureAndGeneratePDF,
    back,
    isMobile,
    handleGoToSales,
    pdfIsLoading
  };
};
